//tslint:disable:export-name
import { ConfigStore } from './ConfigStore';
import { Config } from '../internal/domain/entities/Config';
import { Container } from 'hypo-container';
import { RatingsReviewsService } from './RatingsReviewsService';
import { getDecorators } from 'elc-service';
import { ProductRatingViewController } from '../internal/controllers/ProductRatingViewController';
import { ServiceBusController } from './ServiceBusController';
import { ProductReviewsViewController } from '../internal/controllers/ProductReviewsViewController';
import { ConfigRepository } from '../internal/repositories/ConfigRepository';
import { ProductRepository } from '../internal/repositories/ProductRepository';
import { ReviewSnippetApiSdk } from '../api/ReviewSnippetApiSdk';
import { ReviewSnippetRepository } from '../internal/repositories/ReviewSnippetRepository';
import { root } from 'elc-universal-utils';
import { ReviewDetailsViewController } from '../internal/controllers/ReviewDetailsViewController';
import { getServiceVersion } from 'elc-universal-utils';

export const diContainer = new Container();
export const serviceNames = {
    configStore: 'CONFIG_STORE',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    ratingsReviewsService: 'RATINGS_REVIEWS_SERVICE',
    productRatingViewController: 'PRODUCT_RATING_VIEW_CONTROLLER',
    productReviewsViewController: 'PRODUCT_REVIEWS_VIEW_CONTROLLER',
    reviewDetailsViewController: 'REVIEW_DETAILS_VIEW_CONTROLLER',
    productRepository: 'PRODUCT_REPOSITORY',
    reviewSnippetApiSdk: 'REVIEW_SNIPPET_API_SDK',
    httpTransport: 'HTTP_TRANSPORT',
    reviewSnippetRepository: 'REVIEW_SNIPPET_REPOSITORY',
};

//tslint:disable-next-line:no-any
export const setConfig = (configJSON: any) => {
    diContainer.config = configJSON;
};

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(serviceNames.config, (c) => new Config())
    .register(serviceNames.configRepository, () => new ConfigRepository())
    .register(
        serviceNames.serviceBusController,
        (c) => new ServiceBusController(c.get(serviceNames.reviewSnippetRepository))
    )
    .register(
        serviceNames.ratingsReviewsService,
        (c) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            new RatingsReviewsService((config: any) => {
                setConfig(config);

                return c.get(serviceNames.serviceBusController);
            })
    )
    .register(
        serviceNames.productRatingViewController,
        diContainer.factory(
            (c) => new ProductRatingViewController(c.get(serviceNames.productRepository))
        )
    )
    .register(
        serviceNames.productReviewsViewController,
        diContainer.factory(
            (c) =>
                new ProductReviewsViewController(
                    c.get(serviceNames.config),
                    c.get(serviceNames.productRepository)
                )
        )
    )
    .register(serviceNames.reviewSnippetApiSdk, (c) => {
        const config = {
            httpTransport: c.get(serviceNames.httpTransport),
            configStore: c.get(serviceNames.configStore),
        };
        const reviewSnippetServiceName = serviceNames.reviewSnippetApiSdk;
        const reviewSnippetServiceVersion = getServiceVersion(reviewSnippetServiceName);

        return new ReviewSnippetApiSdk(
            config,
            reviewSnippetServiceName,
            reviewSnippetServiceVersion
        );
    })
    .register(serviceNames.httpTransport, (c) => {
        return root.HttpTransport;
    })
    .register(serviceNames.reviewSnippetRepository, () => new ReviewSnippetRepository())
    .register(
        serviceNames.productRepository,
        (c) => new ProductRepository(c.get(serviceNames.configStore))
    )
    .register(
        serviceNames.reviewDetailsViewController,
        (c) => new ReviewDetailsViewController(c.get(serviceNames.configStore))
    );

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
